<template>
  <form @submit.prevent="handleSubmit" style="min-height: 550px;">
    <div class="row">
      <div class="col-md-6">
        <label for="point_name" class="form-control-label">
          Nombre<span class="required">*</span>
        </label>
        <input
          id="point_name"
          v-model="pointFormModel.name"
          :class="['form-control', pointV.name.$error ? 'is-invalid' : '']"
          type="text"
          placeholder=""
        />
        <p v-if="pointV.name.$error" class="invalid-feedback mb-0">
          <small>
            {{ pointV.name.$errors[0].$message }}
          </small>
        </p>
        <label for="lang" class="form-control-label w-100">
          Idioma<span class="required">*</span>
        </label>
        <el-select
            v-model="pointFormModel.lang"
            size="large"
            class="w-100"
        >
          <el-option
              v-for="selectItem in langs"
              :key="selectItem.id"
              :value="selectItem.value"
              :label="selectItem.name"
          />
        </el-select>
        <p v-if="pointV.lang.$error" class="invalid-feedback invalid-field mb-0">
          <small>
            {{ pointV.lang.$errors[0].$message }}
          </small>
        </p>
        <label for="description" class="form-control-label">
          Descripción<span class="required">*</span>
        </label>
        <textarea
            rows="10"
            id="description"
            v-model="pointFormModel.description"
            :class="[ 'form-control',pointV.description.$error ? 'is-invalid' : '']"
            type="text"
            placeholder=""
        />
        <p v-if="pointV.description.$error" class="invalid-feedback invalid-field mb-0">
          <small>
            {{ pointV.description.$errors[0].$message }}
          </small>
        </p>
      </div>
      <div class="col-md-6">
        <label for="latitude" class="form-control-label">
          Latitud<span class="required">*</span>
        </label>
        <input
            id="latitude"
            v-model="pointFormModel.latitude"
            :class="[
                        'form-control',
                        pointV.latitude.$error ? 'is-invalid' : '',
                      ]"
            type="text"
            placeholder=""
        />
        <p v-if="pointV.latitude.$error" class="invalid-feedback mb-0">
          <small>
            {{ pointV.latitude.$errors[0].$message }}
          </small>
        </p>
        <label for="longitude" class="form-control-label">
          Longitud<span class="required">*</span>
        </label>
        <input
            id="latitude"
            v-model="pointFormModel.longitude"
            :class="[
                        'form-control',
                        pointV.longitude.$error ? 'is-invalid' : '',
                      ]"
            type="text"
            placeholder=""
        />
        <p v-if="pointV.longitude.$error" class="invalid-feedback mb-0">
          <small>
            {{ pointV.longitude.$errors[0].$message }}
          </small>
        </p>
        <label for="video" class="form-control-label">
          Video<span class="required">*</span>
        </label>
        <input
            type="file"
            id="video"
            ref="videoInput"
            @change="handleFileUpload"
            :class="[ 'form-control']"
            placeholder=""
        />
        <div class="img-thumbnail mt-3">
          <video class="w-100 p-2" autoplay muted v-if="previewUrl" :src="previewUrl"></video>
          <p v-if="pointV.videoUrl.$error" class="invalid-feedback mb-0">
            <small>
              {{ pointV.videoUrl.$errors[0].$message }}
            </small>
          </p>
        </div>
      </div>
    </div>
    <div class="mt-3">
      <button
        type="submit"
        class="float-end btn btn-primary text-white bg-blue-600 rounded-lg border border-primary hover:bg-blue-900">
        {{ buttonText }}
      </button>
      <button
        class="me-2 float-end btn btn-primary text-danger bg-white border border-danger rounded-lg hover:bg-blue-900"
        @click="handleCancel"
      >
        Cancelar
      </button>
    </div>
  </form>
</template>

<script setup>
import {ref, defineProps, computed, onMounted, defineEmits, watch} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from 'sweetalert2';
import {languageList} from "@/utils/languages";


const store = useStore();
const router = useRouter();

const props = defineProps({
   entity: {
     type: Object,
     required: false
   },
  parent: {
    type: Object,
    required: false
  },
  action: {
     type: String,
    required: true
  }
})
const pointFormModel = ref(props.entity|| {});
const videoInput = ref(null);
const videoFile = ref(null);
const previewUrl = ref(pointFormModel.value.videoUrl);

const langs = languageList()
const buttonText = computed(() => props.action === 'create' ? 'Crear' : 'Guardar cambios');

const getExperiences = async () => {
  return await store.dispatch("experience/getExperiences");
};

onMounted(async () => {
  await getExperiences();
  if (props.parent) {
    pointFormModel.value.experience = props.parent.id
    pointFormModel.value.lang = props.parent.lang
  }
  if (props.entity.type) {
    pointFormModel.value.type = props.entity.type.id
  }
});

watch(() => props.entity, (value) => {
  pointFormModel.value = value;
  if (value.type) {
    pointFormModel.value.type = value.type.id
  }
  pointV$.value.$reset();
});
const pointRules = computed(() => {
  return {
    name: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    type: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    longitude: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    latitude: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    description: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    lang: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    videoUrl: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    }
  };
});

const pointV$ = useVuelidate(pointRules, pointFormModel, { $scope: 'point' });
const pointV = pointV$.value;
const emit = defineEmits(['addPoint','updatePoint','setLoadingPoint','hideAddForm']);

const clearForm = () => {
  pointFormModel.value = {
    name: null,
    description: null,
    latitude: null,
    longitude: null,
    subtitle: null,
    videoUrl: null,
    type: null,
    file: null,
    lang: 'es',
  };
  if (videoInput.value) {
    videoInput.value.value = null;
  }
  videoFile.value = null;
  previewUrl.value=null;
  pointV$.value.$reset();
};
const handleSubmit = () => {
  pointV$.value.$validate();
  if (!pointV$.value.$invalid) {
    let payload;
    if (videoFile.value) {
      payload = new FormData();
      Object.entries(pointFormModel.value).forEach(([key, value]) => {
        payload.append(key, value ?? '');
      });
      // Agregar el archivo
      payload.append('file', videoFile.value);
    } else {
      payload = {...pointFormModel.value};
    }
    emit('setLoadingPoint', true)
    if(props.action === 'create'){
      //if(props.parent && props.parent.id){
        createEntity(payload)
      //}
      store.dispatch("pointType/getTypeById", typeof pointFormModel.value.type === 'object' ? pointFormModel.value.type.id : pointFormModel.value.type ).then(()=>{
        pointFormModel.value.type = store.state.pointType.currentType
        emit('updatePoint', pointFormModel.value)
      })
      emit('addPoint', pointFormModel.value)
    }else{
      updateEntity(payload)
      emit('updatePoint', pointFormModel.value)
    }

  }
};

const handleCancel = () => {
  //router.push({ name: "Puntos", params: {} });
  clearForm();
  emit('hideAddForm');
};

const createEntity = async (data) => {
  pointFormModel.value.experience = props.parent.id
  if(pointFormModel.value.type?.id){
    pointFormModel.value.type = pointFormModel.value.type.id
  }
  await store.dispatch("point/add", data).then(async (res) => {
    if (res.status && (res.status === 200 || res.status === 201)) {
      pointFormModel.value.id = res.data.id
      store.dispatch("pointType/getTypeById", typeof pointFormModel.value.type === 'object' ? pointFormModel.value.type.id : pointFormModel.value.type ).then(()=>{
        pointFormModel.value.type = store.state.pointType.currentType
        emit('updatePoint', pointFormModel.value)
      })
      emit('setLoadingPoint', false)

      await Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Punto de interés creado satisfactoriamente.',
        showConfirmButton: false,
        timer: 3000
      })
      clearForm()

      await router.push({name: 'Actualizar-Experiencia',
        params: { id: props.parent.id }});
    } else{
      emit('setLoadingPoint', false)
      await Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Se ha producido un error.',
        showConfirmButton: false,
        timer: 3000
      })
    }

  });

}

const updateEntity = async (data) => {
  if(pointFormModel.value.type?.id){
    pointFormModel.value.type = pointFormModel.value.type.id
  }
  await store.dispatch("point/edit", data).then(async (res) => {
    if (res.status && (res.status === 200 || res.status === 201)) {
      store.dispatch("pointType/getTypeById", pointFormModel.value.type).then(()=>{
        pointFormModel.value.type = store.state.pointType.currentType
        emit('updatePoint', pointFormModel.value)
      })
      emit('setLoadingPoint', false)

      await Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Punto de interés editado satisfactoriamente.',
        showConfirmButton: false,
        timer: 3000
      })
      clearForm()
      await router.push({name: 'Actualizar-Experiencia',
        params: { id: props.parent.id }});
    } else{
      emit('setLoadingPoint', false)
      await Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Se ha producido un error.',
        showConfirmButton: false,
        timer: 3000
      })
    }

  });

}
const handleFileUpload = (e) => {
  const file = e.target.files[0];
  if (file) {
    videoFile.value = file;
    previewUrl.value = URL.createObjectURL(file);
    pointFormModel.value.videoUrl = URL.createObjectURL(file);
  }
};


</script>
